import { toast } from "sonner";
import { api } from "../../../../services/axios";
type DesignFile = {
  id: string;
  author: string;
  campaign: string;
  created_at: string;
  configurable: boolean;
  original_file_name: string;
  file_name: string;
  file_url: string;
  design_colors: string[];
};

export function FileHistoryTable({
  designFiles,
}: {
  designFiles: DesignFile[];
}) {
  function deleteFile(designId: string) {
    return api
      .delete(`design-files/${designId}`)
      .then(() => toast.success("deleted", { duration: 5000 }))
      .catch((e) => toast.error(e.message, { duration: 5000 }));
  }

  return (
    <div className="w-full p-8 m-4 border rounded">
      <div className="flex-1 min-w-0 w-full">
        <h4 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
          Files
        </h4>
      </div>
      <div className="w-full pt-4">
        {designFiles && designFiles.length > 0 && (
          <table className="table-fixed w-full border-collapse text-xs">
            <thead>
              <tr>
                <th className="border border-deeppurple">created</th>
                <th className="border border-deeppurple">configurable</th>
                <th className="border border-deeppurple">original_file_name</th>
                <th className="border border-deeppurple">file_url</th>
                <th className="border border-deeppurple">delete</th>
              </tr>
            </thead>
            <tbody>
              {designFiles.map((design: DesignFile, index) => {
                return (
                  <tr className="p-2 m-2 group" key={index}>
                    <td className="p-2 border border-deeppurple truncate group-hover:bg-gray-50">
                      {design.created_at}
                    </td>
                    <td className="p-2 border border-deeppurple truncate group-hover:bg-gray-50">
                      {design.configurable ? "yes" : "no"}
                    </td>
                    <td className="p-2 border border-deeppurple group-hover:bg-gray-50">
                      {design.original_file_name}
                    </td>
                    <td className="p-2 border border-deeppurple truncate group-hover:bg-gray-50">
                      <a href={design.file_url} download>
                        <p className="underline">Download</p>
                      </a>
                    </td>
                    <td className="p-2 border border-deeppurple truncate group-hover:bg-gray-50">
                      <button onClick={() => deleteFile(design.id)}>
                        <p>Delete</p>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
